import { findWorkflowFunction } from '@shared/workflow/findWorkflowFunction.js';

const updateWorkflowFunction = ({ entries = [], payload, loading = false }) => {
  const { functionId, functionSnapshotId, companyId, requestId } = payload.meta;
  const step = { functionId, options: { functionSnapshotId } };
  const existing = findWorkflowFunction({ step, workflowFunctions: entries });
  if (!loading && existing?.requestId !== requestId) {
    return entries;
  }
  const workflow = payload.success !== false ? payload.data?.[0] : undefined;
  const available = workflow?.type === 'function';
  const isDraftFallback = functionSnapshotId === null && payload.meta.isDraftFallback === true && available;
  const entry = {
    ...(available ? workflow : {}),
    id: functionId,
    functionSnapshotId,
    companyId,
    requestId,
    isLoading: loading,
    isDraftFallback,
    error: isDraftFallback ? 'The published version is unavailable. Showing draft inputs.' : !loading && !available ? payload.message || 'The selected function version is unavailable.' : null
  };
  return [...entries.filter((item) => item !== existing), entry];
};

export default updateWorkflowFunction;
